import styled from "styled-components"

import { Span } from "./span"

export const Text = styled(Span).attrs(() => ({ as: "p" }))`
  ${(props) =>
    props.simple && `margin: 0px;`
  }
  ${(props) =>
    props.center && `text-align: center;`
  }
  font-size: ${(props) => (props.size ? props.size : "14px")};

  letter-spacing: ${(props) =>
    props.letterSpacing ? props.letterSpacing : "unset"} !important;
  align-self: center;
  ::before {
    content: "${(props) => props.beforeContent}";
    color: ${(props) => props.beforeColor};
  }

  ::after {
    content: "${(props) => props.afterContent}";
    color: ${(props) => props.afterColor};
  }
`

export default Text
